import { render } from "./App.vue?vue&type=template&id=4f67896a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&scope=true&lang=css"
script.render = render

export default script